import { Reveal } from "@/components/landing/Reveal";
import GuardianDonationWidget from "@/components/donation/GuardianDonationWidget";

export function GuardianRepeatSection() {
  return (
    <section className="bg-amtm-bg py-20 md:py-28 border-t border-amtm-border" data-testid="landing-guardian-repeat">
      <div className="max-w-5xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-10 md:gap-14 items-center">
        <Reveal>
          <p className="text-xs md:text-sm font-semibold uppercase tracking-[0.18em] text-amtm-teal mb-4">
            Join Our Guardians
          </p>
          <h2 className="font-display text-3xl md:text-4xl text-amtm-text mb-4 leading-tight">
            Still thinking it over?
          </h2>
          <p className="text-amtm-textMuted leading-relaxed max-w-md">
            A monthly gift, however small, is what lets us say yes to the next emergency without hesitating. You can
            change or cancel it anytime.
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <GuardianDonationWidget testIdPrefix="guardian-repeat" />
        </Reveal>
      </div>
    </section>
  );
}
